import { HttpInterceptorFn } from '@angular/common/http';

function generateTraceparent(): string {
    const traceId = Array.from(crypto.getRandomValues(new Uint8Array(16)))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
    const spanId = Array.from(crypto.getRandomValues(new Uint8Array(8)))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
    return `00-${traceId}-${spanId}-01`;
}

// In non-local environments, distributed tracing is handled by the Sentinel package (New Relic).
export const localTracingInterceptorFn: HttpInterceptorFn = (req, next) => {
    if (req.headers.has('traceparent')) {
        return next(req);
    }
    return next(req.clone({ headers: req.headers.set('traceparent', generateTraceparent()) }));
};
